export default[
  {
    id:0,
    img:"images/boy.jpeg",
    price:"30 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
    label:"URGENT",

  },
  {
    id:1,
    img:"images/shiva.jpg",
    price:"50 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },

  {
    id:2,
    img:"images/dog.jpg",
    price:"60 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
    labeld:"UN d"

  },
  {
    id:3,
    img:"images/dog.jpg",
    price:"70 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
    label:"URGENT",
  },
  {
    id:4,
    img:"images/boy.jpeg",
    price:"30 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },
  {
    id:5,
    img:"images/shiva.jpg",
    price:"50 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },

  {
    id:6,
    img:"images/dog.jpg",
    price:"60 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },
  {
    id:7,
    img:"images/dog.jpg",
    price:"70 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
   labeld:"UN d"
  },
  {
    id:8,
    img:"images/boy.jpeg",
    price:"30 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },
  {
    id:9,
    img:"images/shiva.jpg",
    price:"50 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },

  {
    id:10,
    img:"images/dog.jpg",
    price:"60 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
    label:"URGENT",
  },
  {
    id:11,
    img:"images/dog.jpg",
    price:"70 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China"
  },
  {
    id:12,
    img:"images/boy.jpeg",
    price:"30 $",
    name:"Highlander Men Solid Casual Mandarin Shirt",
    address:"Xiamen, Fujian, China",
    labeld:"UN d"
  },
  {
    id:13,
    img:"images/jeans.jpg",
    price:"30 $",
    name:"jeans",
    address:"Xiamen, Fujian, China",
    labeld:"UN d"
},
{
  id:14,
  img:"images/scandal.jpeg",
  price:"10$",
  name:"Scandal",
  address:"xinan, China",
},
{
  id:15,
  img:"images/cycle1.jpg",
  price:"10$",
  name:"Scandal",
  address:"xinan, China",
},
{
  id:16,
  img:"images/bike.jpg",
  price:"15$",
  name:"Bikes",
  address:"xinan, China",
},
{
  id:17,
  img:"images/boy1.jpeg",
  price:"10$",
  name:"Boy",
  address:"xinan, China",
},
{
  id:18,
  img:"images/cars.jpeg",
  price:"10$",
  name:"Scandal",
  address:"xina,saia,China",
  label:"urgent"
},
{
  id:19,
  img:"images/cycle1.jpg",
  price:"20$",
  name:"Cycle",
  address:"xinan, China",
},

{
  id:20,
  img:"images/person.jpg",
  price:"20$",
  name:"Abdul",
  address:"xinan, China",
 label:"important"
},
{
  id:21,
  img:"images/wanted.jpg",
  price:"01$",
  name:"book cover",
  address:"xinan, China",
},

{
  id:22,
  img:"images/car_2.jpg",
  price:"20$",
  name:"car",
  address:"xinan, China",
},

{
  id:23,
  img:"images/car_3.jpg",
  price:"20$",
  name:"car",
  address:"xinan, China",
  labeld:"UN d"

},









]